import { __decorate } from "tslib";
import Component from "vue-class-component";
import Task from "@/services/task";
import ReactiveComponent from "@/components/ReactiveComponent";
import Formatter from "@/utils/formatter";
import TemplateContent from "@/components/template/TemplateContent.vue";
import { parse, format } from "date-fns";
var Column;
(function (Column) {
    Column["name"] = "name";
    Column["action"] = "action";
})(Column || (Column = {}));
let CompetitionsList = class CompetitionsList extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.tdClass = "competitions-datatable";
        this.fields = [
            { key: "name", label: "Name", sortable: true, tdClass: this.tdClass },
            {
                key: "location",
                label: "Location",
                sortable: true,
                tdClass: this.tdClass
            },
            { key: "boards", label: "Boards", sortable: false, tdClass: this.tdClass },
            {
                key: "date_start",
                label: "Start date",
                sortable: true,
                tdClass: this.tdClass
            },
            {
                key: "date_end",
                label: "End date",
                sortable: true,
                tdClass: this.tdClass
            },
            { key: "actions", label: "Actions", sortable: false, tdClass: this.tdClass }
        ];
        this.competitionsQuery = { competitions: [] };
        this.competitionsTask = Task.idle();
        this.deleteTask = Task.idle();
    }
    created() {
        this.subscribeQuery({
            tag: "competitions",
            options: {
                query: require("@/apollo/queries/competitionsList.graphql")
            },
            onTask: task => {
                this.competitionsTask = task;
                if (task.isSuccessful) {
                    this.competitionsQuery = task.data;
                }
            }
        });
    }
    get competitions() {
        return this.competitionsQuery.competitions;
    }
    formatBoards(competition) {
        return Formatter.formatBoards(competition.boards_competitions.map(it => it.board));
    }
    formatDate(date) {
        const d = parse(date);
        return format(d, "DD/MM/YYYY");
    }
    async deleteCompetition(competitionId) {
        const competition = this.competitions.find(it => it.id === competitionId);
        if (competition == undefined) {
            return;
        }
        const result = await this.$bvModal.msgBoxConfirm(`Delete ${competition.name}?\nThis action is definitive`, {
            size: "sm",
            buttonSize: "md",
            okVariant: "danger",
            okTitle: "Delete",
            cancelTitle: "Cancel",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
        });
        if (result !== true) {
            return;
        }
        const competitionsQuery = require("@/apollo/queries/competitionsList.graphql");
        this.subscribeMutation({
            tag: "deleteCompetition",
            options: {
                mutation: require("@/apollo/mutations/deleteCompetition.graphql"),
                variables: {
                    id: competition.id
                },
                update: (store, { data }) => {
                    try {
                        const competitionsListQueryData = store.readQuery({ query: competitionsQuery });
                        if (data.delete_competitions.affected_rows != 1) {
                            return;
                        }
                        const index = competitionsListQueryData.competitions.findIndex(it => it.id == competition.id);
                        if (index < 0) {
                            return;
                        }
                        competitionsListQueryData.competitions.splice(index, 1);
                        store.writeQuery({
                            query: competitionsQuery,
                            data: competitionsListQueryData
                        });
                    }
                    catch (e) {
                        console.log("Failed to update cache after delete_user mutation");
                    }
                },
                optimisticResponse: {
                    __typename: "mutation_root",
                    delete_competitions: {
                        __typename: "competitions_mutation_response",
                        affected_rows: 1
                    }
                }
            },
            onTask: task => (this.deleteTask = task)
        });
    }
};
CompetitionsList = __decorate([
    Component({
        components: { TemplateContent }
    })
], CompetitionsList);
export default CompetitionsList;
